import { Box, HStack } from "@chakra-ui/react";
import React from "react";
import LeftSidebar from "../../components/LeftSideBarLayout/LeftSideBar";
import HeaderBar from "../../components/Header/HeaderBar";
import DistributorCNFSummary from "../../components/Distributor/DistributorCNF";
import Footer from "../../components/footer";

const Distributor = () => {
    return (
        <Box backgroundColor='#F0F4F9' height="100vh" overflow={"hidden"}>
            <HStack pl='20px' pr='6px' alignItems='flex-start' spacing={0} w="100%" overflow={"hidden"}>
                <LeftSidebar />
                <Box as="main" flex="1" minW="0" ml="6px" overflow={"hidden"}>
                    <HeaderBar />
                    <DistributorCNFSummary />
                    <Footer />
                </Box>
            </HStack>
        </Box>
    );
};

export default Distributor;